import React from 'react';

import './OptionInput.css';

function OptionInput({
    children,
    id,
    name,
    value,
    onChange,
    checked,
    required,
    label,
}) {
    return (
        <div className="OptionInput">
            <input
                id={id}
                name={name}
                className="OptionInput__input"
                value={value}
                onChange={onChange}
                type="radio"
                checked={checked}
                required={required}
            />
            <label className="OptionInput__label" htmlFor={id}>
                {children}
                {label ? (
                    <span className="OptionInput__label-text">{label}</span>
                ) : null}
            </label>
        </div>
    );
}

export default OptionInput;
